import { Controller } from "@hotwired/stimulus"

// Copies a value to the clipboard and confirms on the button itself, so the
// feedback lands where the click did rather than in a toast elsewhere.
// Registered as "clipboard", it replaces Plutonium's controller, so it also
// takes Plutonium's contract: the text of a `source` target.
export default class extends Controller {
  static targets = ["source"]
  static values = { text: String }

  get text() {
    if (!this.hasSourceTarget) return this.textValue
    return this.sourceTarget.value || this.sourceTarget.textContent
  }

  async copy(event) {
    const button = event.currentTarget
    const original = button.textContent

    try {
      await navigator.clipboard.writeText(this.text)
      button.textContent = "Copied"
    } catch {
      // Clipboard access needs a secure context, so say what to do instead.
      button.textContent = "Press ⌘C"
    }

    setTimeout(() => { button.textContent = original }, 2000)
  }
}
